import React, { useRef, useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import WhatIsThis from './components/Story';
import WhySharingMatters from './components/WhatIsYUP';
import Pillars from './components/Pillars';
import JasonSection from './components/JasonSection';
import NotBroken from './components/NotBroken';
import HowItWorks from './components/HowItWorks';
import PreRegisterForm from './components/PreRegisterForm';
import Footer from './components/Footer';
import Dashboard from './components/Dashboard';
import PractitionerCallout from './components/PractitionerCallout';
import { trackPageView, initScrollDepth } from './lib/analytics';

function App() {
  const formRef = useRef(null);
  const isDashboard =
    typeof window !== 'undefined' &&
    /^\/dashboard\/?$/.test(window.location.pathname);

  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      document.getElementById('register')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (isDashboard) return;
    trackPageView('/');
    const cleanup = initScrollDepth('/');
    return cleanup;
  }, [isDashboard]);

  if (isDashboard) {
    return <Dashboard />;
  }

  return (
    <div className="App">
      <Header />

      <main>
        <Hero onCTAClick={scrollToForm} />
        <WhatIsThis />
        <WhySharingMatters />
        <Pillars />
        <PractitionerCallout />
        <JasonSection />
        <NotBroken />
        <HowItWorks />
        <div ref={formRef}>
          <PreRegisterForm />
        </div>
      </main>

      <Footer />

      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
